import { call } from 'redux-saga/effects';

import { getFiledReturnFile } from '@api/vatReturn';
import { downloadRequest } from '@helpers/api';

export const handleDownloadFiledReturn = function* ({ payload }) {
  const file = yield call(getFiledReturnFile, payload.id);
  yield call(
    downloadRequest,
    file.url,
    payload.filename,
    { baseURL: '' },
    { noAuth: true, skipAuthRefresh: true }
  );
};
